import { ColorV2 } from "config/colors";
import styled from "styled-components";

export const TeamFieldWrap = styled.div`
  margin-top: 8px;
`;

export const TeamModalError = styled.p`
  margin: 12px 0 0;
  font-size: 12px;
  color: ${ColorV2.NegativeRed};
`;
